module.exports = __webpack_public_path__ + "static/media/Portrait-10076.890f0a6a.jpg";